import { I18n } from '@/i18n/I18n';

export function VideoOutput(props: { source: string}) {
  const { source } = props;


  const handleVideoError = (error: any) => {
    if (!error?.target?.error) return;
    if (error.target.error.code === 3) {
      const video = error.target as HTMLVideoElement;
      const currentTime = video?.currentTime;

      const handleReadyStateChange = () => {
        if (video.readyState >= 2) {
          video.removeEventListener('canplaythrough', handleReadyStateChange);
          void video.play();
        }
      };

      const handleLoadedData = () => {
        if (video.readyState >= 2) {
          video.currentTime = currentTime;
          video.addEventListener('canplaythrough', handleReadyStateChange);
          video.removeEventListener('loadeddata', handleLoadedData);
        }
      };

      video.addEventListener('loadeddata', handleLoadedData);

      video.src = `${video.src  }?nocache=${new Date().getTime()}`;
      video.load();
    }
  };

  return (
    <div className="col text-center">
      <div className="embed-responsive embed-responsive-16by9">
        <video onError={handleVideoError} aria-label={I18n.get('commandingRunVideo')} muted controls preload='auto' src={source} className='w-100' />
      </div>
    </div>
  );
}
